<template>
    <b-modal v-model="openModal" no-close-on-backdrop hide-header hide-footer centered class="modal-cookie">
      <div class="cookie-selection">
          <b-tabs content-class="mt-3" active-nav-item-class="bg-cuaternary font-weight-bold text-terciary border-bottom border-terciary" pills v-model="tab">
            <b-tab title="Consentimiento" active title-link-class="text-terciary">
              <b-card-text class="mt-2">
                <span class="">
                <b>Esta página web usa cookies</b>
                </span>
                <br />
                <small>
                  Si autorizas, cuando visites este sitio web almacenaremos o recuperaremos información en el
                  navegador a través de cookies no necesarias. La información que captemos permitirá que el sitio
                  funcione como esperas que lo haga y se adecue de mejor manera a tus preferencias.
                  No autorizar algunos tipos de cookies puede afectar tu experiencia en el sitio,
                  así como los servicios que te podemos ofrecer.
                </small>
              </b-card-text>
            </b-tab>
            <b-tab title="Detalles" title-link-class="text-terciary">
              <b-card-text class="mt-2">
                <div class="accordion mt-2" role="tablist">
                  <b-card no-body class="mb-1" v-for="(cookie, idx) of cookieList" :key="idx">
                    <b-card-header header-tag="header" class="p-3" role="tab">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex align-items-center" block v-b-toggle="`accordion-${idx+1}`">
                          <i class="fa fa-chevron-down"></i>
                          <div class="ml-2">{{cookie.title}}</div>
                        </div>
                        <input type="checkbox" :disabled="cookie.disabled" v-model="cookie.isChecked">
                      </div>
                    </b-card-header>
                    <b-collapse :id="`accordion-${idx+1}`" visible accordion="my-accordion" role="tabpanel">
                      <b-card-body>
                        <b-card-text>{{ cookie.description }}</b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </b-card-text>
            </b-tab>
            <b-tab title="Acerca de las cookies" title-link-class="text-terciary">
              <b-card-text class="mt-2">
                <small class="">
                  La aceptación o no del uso de cookies no necesarias no condiciona la navegación en el sitio web
                  ni la prestación de los servicios que nos solicites. En cualquier momento podrás ejercer tu derecho
                  de desactivación o eliminación de las no necesarias en la sección de Privacidad de tu navegador.
                  Si lo autorizas, al tratamiento de la información que captemos le resultará aplicable nuestra Política de Privacidad.
                </small>
              </b-card-text>
            </b-tab>
          </b-tabs>
          <div class="d-flex align-items-center justify-content-between flex-wrap mt-2" style="gap:2px">
            <div class="btn bg-terciary text-white col-12 col-sm-auto" @click="chooseAllCookies(false)">Denegar</div>
            <div
              class="btn bg-terciary text-white col-12 col-sm-5 my-2"
              @click="tab != 1 ? tab = 1 : customizationCookies()">
              {{ tab != 1 ? 'Personalizar' : 'Permitir selección' }}
            </div>
            <div class="btn bg-terciary text-white col-12 col-sm-4" @click="chooseAllCookies(true)">Permitir todas</div>
          </div>
      </div>
    </b-modal>
</template>
<script>
import { cookieDetailList } from "../../utils/cookies"

export default {
  data() {
    return{
      openModal: true,
      step: 1,
      cookieList: cookieDetailList,
      tab:0,
    }
  },
  methods:{
    customizationCookies() {
      this.$emit('isCustomizable', this.cookieList)
    },
    async chooseAllCookies(isAccept){
      try {
        const clonCookiesList = this.cookieList;
        this.cookieList = clonCookiesList.map((c) => ({
          ...c,
          isChecked: c.title === 'Necesario' || isAccept,
        }));
        this.$emit('isAceptAll', {cookie: this.cookieList, isAccept })
      } catch (error) {
        // eslint-disable-next-line
        console.error('error', error);
      }
    }
  }
}
</script>

